import React from 'react'

import { adminAdmins } from '../../../core/controllers/Admin/AdminAdmins'

export default class TotalAdminsCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalAdmins: 0
        };
    }

    componentDidMount() {
        var self = this;
        adminAdmins.getAdmins(function(response){
            self.setState({
                totalAdmins: response.data.length
            })
        })
    }

    render() {
        const totalAdmins = this.state.totalAdmins;
        return (
            <div class="col-md-3 col-sm-6 col-xs-12">
                <div class="info-box">
                    <span class="info-box-icon green-icon-circle"><i class="icon-person-group"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Total</span>
                        <br/>
                        <span class="info-box-subtext">Total admins</span>
                        <span class="info-box-number green-info-number">{totalAdmins}</span>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Admins/TotalAdminsCard.jsx